import { millwrightsRiskOptions } from '@/constants';
import { MillwrightsFiltersI } from '@/types';
import { useState } from 'react';

const initialFilters = {
  riskFactor: millwrightsRiskOptions[0],
};

interface UseMillwrightsFiltersOptions {
  initialFilters?: Partial<MillwrightsFiltersI>;
}

const getInitialFilters = (
  overrides?: Partial<MillwrightsFiltersI>,
): MillwrightsFiltersI => ({
  ...initialFilters,
  ...overrides,
});

export const useMillwrightsFilters = ({
  initialFilters: initialFiltersOverrides,
}: UseMillwrightsFiltersOptions = {}) => {
  const [millwrightsFilters, setMillwrightsFilters] =
    useState<MillwrightsFiltersI>(
      getInitialFilters(initialFiltersOverrides),
    );

  const updateFilters = (filters: Partial<MillwrightsFiltersI>) => {
    setMillwrightsFilters((prevState) => ({ ...prevState, ...filters }));
  };

  const resetFilters = () => {
    setMillwrightsFilters(getInitialFilters(initialFiltersOverrides));
  };

  return {
    millwrightsFilters,
    resetFilters,
    updateFilters,
  };
};
